import { render, staticRenderFns } from "./index.vue?vue&type=template&id=944274da&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=944274da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944274da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('944274da')) {
      api.createRecord('944274da', component.options)
    } else {
      api.reload('944274da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=944274da&scoped=true", function () {
      api.rerender('944274da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/skus/index.vue"
export default component.exports